export { default as CoverEditor } from './CoverEditor'
export { default as ExecutiveSummaryEditor } from './ExecutiveSummaryEditor'
export { default as IntroEditor } from './IntroEditor'
export { default as ScopeEditor } from './ScopeEditor'
export { default as StartupEditor } from './StartupEditor'
export { default as ProjectEditor } from './ProjectEditor'
export { default as NotesEditor } from './NotesEditor'
export { default as TermsEditor } from './TermsEditor'
export { default as AboutEditor } from './AboutEditor'
export { default as ServiceAreaEditor } from './ServiceAreaEditor'

const EDITOR_COMPONENTS = {
  cover: require('./CoverEditor').default,
  executiveSummary: require('./ExecutiveSummaryEditor').default,
  intro: require('./IntroEditor').default,
  about: require('./AboutEditor').default,
  scope: require('./ScopeEditor').default,
  serviceArea: require('./ServiceAreaEditor').default,
  startup: require('./StartupEditor').default,
  project: require('./ProjectEditor').default,
  notes: require('./NotesEditor').default,
  terms: require('./TermsEditor').default,
}

export default EDITOR_COMPONENTS
